import * as Sentry from '@sentry/vue'

export const handleError = (err: Error) => {
  if (window.location.href.indexOf('localhost') > -1) {
    console.log('[ERROR]', err)
  } else {
    Sentry.captureException(err)
    console.log('here')
  }
}

export const handleErrorMessage = (msg: string) => {
  if (window.location.href.indexOf('localhost') > -1) {
    console.log('[ERROR]', msg)
  } else {
    Sentry.captureMessage(msg)
  }
}
